// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #403d39;
  --highlight-color: #613db0;
  --bg-color: #fffcf3;
  --viz-width: 400px;
}

a {
  transition: color 200ms;
  border: 1px solid transparent;
  color: currentColor;
  text-decoration-color: var(--highlight-color);
  text-decoration-thickness: 1px;
  text-underline-offset: 0.25rem;
}

a:hover {
  color: var(--highlight-color);
}

body,
html {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  color: var(--primary-color);
  background-color: var(--bg-color);
  font-weight: 300;
  margin: 0;
  padding: 0;
}

body {
  display: flex;
  flex-direction: column;
}

p {
  line-height: 1.4;
}

.title {
  margin-bottom: 1em;
}

h1 {
  font-weight: 600;
}

.title > h1,
div {
  margin: 0;
}

main {
  flex: 1 0 auto;
  display: flex;
  justify-content: center;
}

#canvas {
  width: 100%;
  margin: 0 auto;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  max-width: 960px;
  width: 100%;
  padding: 1em;
  box-sizing: border-box;
}

.container > .left {
  flex: 0 1 var(--viz-width);
  max-width: var(--viz-width);
  display: flex;
  flex-direction: column;
  align-items: center; /* Horizontally center contents */
  justify-content: center; /* Vertically center contents */
  margin-top: 2em;
}

.container > .right {
  flex: 1;
  width: 100%;
  padding: 1em;
  box-sizing: border-box;
  max-width: 600px;
  margin: 0 auto;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

/* Small screens: Stack left & right vertically, limit left height */
@media (max-width: 600px) {
  .container {
    flex-direction: column;
    gap: 1.5em;
    align-items: center;
  }

  .container > .left {
    max-height: 500px;
    width: 100%;
  }
}

/* Medium screens: Ensure proper right container size */
@media (min-width: 768px) and (max-width: 960px) {
  .container {
    flex-direction: row;
    align-items: flex-start; /* Align left to right container's height */
    gap: 2em;
  }

  .container > .left {
    flex: 0 1 50%; /* Allow it to shrink if needed */
    max-width: 50%;
  }

  .container > .right {
    flex: 1; /* Allow right container to take more space */
    max-width: 65%;
    padding: 1.5em;
    margin: 0 auto;
  }
}

/* Wide screens: Left and right should match width & height */
@media (min-width: 960px) {
  .container {
    flex-flow: row nowrap;
    padding: 2em;
    align-items: flex-start; /* Ensure left height matches right */
  }

  .container > .left,
  .container > .right {
    flex: 1;
    max-width: 50%;
  }

  .container > .right {
    padding: 2em;
  }
}

footer {
  flex: 0 0 auto;
  display: flex;
  margin: 1em;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,6CAA6C;EAC7C,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;EACZ;+EAC6E;EAC7E,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,iCAAiC;EACtD,uBAAuB,EAAE,+BAA+B;EACxD,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE;IACE,sBAAsB;IACtB,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA,uDAAuD;AACvD;EACE;IACE,mBAAmB;IACnB,uBAAuB,EAAE,2CAA2C;IACpE,QAAQ;EACV;;EAEA;IACE,aAAa,EAAE,iCAAiC;IAChD,cAAc;EAChB;;EAEA;IACE,OAAO,EAAE,6CAA6C;IACtD,cAAc;IACd,cAAc;IACd,cAAc;EAChB;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,qBAAqB;IACrB,YAAY;IACZ,uBAAuB,EAAE,qCAAqC;EAChE;;EAEA;;IAEE,OAAO;IACP,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB","sourcesContent":[":root {\n  --primary-color: #403d39;\n  --highlight-color: #613db0;\n  --bg-color: #fffcf3;\n  --viz-width: 400px;\n}\n\na {\n  transition: color 200ms;\n  border: 1px solid transparent;\n  color: currentColor;\n  text-decoration-color: var(--highlight-color);\n  text-decoration-thickness: 1px;\n  text-underline-offset: 0.25rem;\n}\n\na:hover {\n  color: var(--highlight-color);\n}\n\nbody,\nhtml {\n  height: 100%;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,\n    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';\n  color: var(--primary-color);\n  background-color: var(--bg-color);\n  font-weight: 300;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  display: flex;\n  flex-direction: column;\n}\n\np {\n  line-height: 1.4;\n}\n\n.title {\n  margin-bottom: 1em;\n}\n\nh1 {\n  font-weight: 600;\n}\n\n.title > h1,\ndiv {\n  margin: 0;\n}\n\nmain {\n  flex: 1 0 auto;\n  display: flex;\n  justify-content: center;\n}\n\n#canvas {\n  width: 100%;\n  margin: 0 auto;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  max-width: 960px;\n  width: 100%;\n  padding: 1em;\n  box-sizing: border-box;\n}\n\n.container > .left {\n  flex: 0 1 var(--viz-width);\n  max-width: var(--viz-width);\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* Horizontally center contents */\n  justify-content: center; /* Vertically center contents */\n  margin-top: 2em;\n}\n\n.container > .right {\n  flex: 1;\n  width: 100%;\n  padding: 1em;\n  box-sizing: border-box;\n  max-width: 600px;\n  margin: 0 auto;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n}\n\n/* Small screens: Stack left & right vertically, limit left height */\n@media (max-width: 600px) {\n  .container {\n    flex-direction: column;\n    gap: 1.5em;\n    align-items: center;\n  }\n\n  .container > .left {\n    max-height: 500px;\n    width: 100%;\n  }\n}\n\n/* Medium screens: Ensure proper right container size */\n@media (min-width: 768px) and (max-width: 960px) {\n  .container {\n    flex-direction: row;\n    align-items: flex-start; /* Align left to right container's height */\n    gap: 2em;\n  }\n\n  .container > .left {\n    flex: 0 1 50%; /* Allow it to shrink if needed */\n    max-width: 50%;\n  }\n\n  .container > .right {\n    flex: 1; /* Allow right container to take more space */\n    max-width: 65%;\n    padding: 1.5em;\n    margin: 0 auto;\n  }\n}\n\n/* Wide screens: Left and right should match width & height */\n@media (min-width: 960px) {\n  .container {\n    flex-flow: row nowrap;\n    padding: 2em;\n    align-items: flex-start; /* Ensure left height matches right */\n  }\n\n  .container > .left,\n  .container > .right {\n    flex: 1;\n    max-width: 50%;\n  }\n\n  .container > .right {\n    padding: 2em;\n  }\n}\n\nfooter {\n  flex: 0 0 auto;\n  display: flex;\n  margin: 1em;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
